import { render, staticRenderFns } from "./InsightsKpis.vue?vue&type=template&id=ccfb6d3e&scoped=true"
import script from "./InsightsKpis.vue?vue&type=script&lang=js"
export * from "./InsightsKpis.vue?vue&type=script&lang=js"
import style0 from "./InsightsKpis.vue?vue&type=style&index=0&id=ccfb6d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfb6d3e",
  null
  
)

export default component.exports